class AsyncInterval {
    private cancelled = false;
    private timeoutID: NodeJS.Timeout;

    private readonly timeoutMS: number;
    private readonly callback: () => Promise<unknown>;

    constructor(
        callback: () => Promise<unknown>,
        timeoutMS: number,
        delayFirstExecution = false,
    ) {
        this.timeoutMS = timeoutMS;
        this.callback = callback;

        // Schedule immediate first execution instead of using timeoutMS
        if (delayFirstExecution) {
            this.timeoutID = setTimeout(this.exec, timeoutMS);
        } else {
            this.timeoutID = setTimeout(this.exec);
        }
    }

    private exec = async () => {
        await this.callback();

        if (!this.cancelled) {
            this.timeoutID = setTimeout(this.exec, this.timeoutMS);
        }
    };

    cancel() {
        this.cancelled = true;
        clearTimeout(this.timeoutID);
    }
}

export default AsyncInterval;
